import { Component, EventEmitter, input, Output } from '@angular/core';

@Component({
    selector: 'app-header-divisor',
    imports: [],
    templateUrl: './header-divisor.html',
    styleUrl: './header-divisor.scss'
})
export class HeaderDivisor {
    label = input<string>('');
    icon = input<string>('');
    description = input<string>('');
    useEditButton = input<boolean>(false);
    modoEdicao = input<boolean>(false);
    disableEdit = input<boolean>(false);
    loading = input<boolean>(false);

    @Output() onAction = new EventEmitter<void>();
    @Output() editar = new EventEmitter<void>();
    @Output() salvar = new EventEmitter<void>();
    @Output() cancelar = new EventEmitter<void>();
}
